export default __webpack_public_path__ + "assets/images/ph-icon-dc97dc38.svg";